var _circle, _circle2, _circle3, _circle4, _path, _mask, _path2, _path3, _mask2, _path4, _path5, _line, _mask3, _path6, _path7, _line2, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharcoal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 259,
    viewBox: "0 0 848 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 733.894,
    cy: 207.985,
    r: 43.1667,
    fill: "white",
    stroke: "black",
    strokeWidth: 15.697
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.788,
    cy: 207.985,
    r: 43.1667,
    fill: "white",
    stroke: "black",
    strokeWidth: 15.697
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.122,
    cy: 207.985,
    r: 43.1667,
    fill: "black",
    stroke: "white",
    strokeWidth: 15.697
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.015,
    cy: 207.985,
    r: 43.1667,
    fill: "black",
    stroke: "white",
    strokeWidth: 15.697
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717.147 138.02C769.215 129.502 788.836 160.896 796.685 172.668C804.533 184.441 808.457 196.214 820.23 196.214C832.003 196.214 839.851 196.214 839.851 175.731C839.851 155.248 828.366 118.686 820.709 103.372C813.052 88.0576 801.566 88.0576 801.566 88.0576H231.115",
    stroke: "black",
    strokeWidth: 15.697
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_1091_9218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.056 23.5455C286.056 10.5417 296.597 0 309.601 0H521.985H675.991H694.652C705.489 0 714.273 8.78471 714.273 19.6212C714.273 28.7713 708.01 36.4585 699.537 38.6296V45.7496V60.6822V84.0349H679.018C678.027 84.1621 677.017 84.2276 675.991 84.2276H309.601C308.576 84.2276 307.565 84.1621 306.574 84.0349H286.056V60.6822V45.7496V23.5455Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.056 23.5455C286.056 10.5417 296.597 0 309.601 0H521.985H675.991H694.652C705.489 0 714.273 8.78471 714.273 19.6212C714.273 28.7713 708.01 36.4585 699.537 38.6296V45.7496V60.6822V84.0349H679.018C678.027 84.1621 677.017 84.2276 675.991 84.2276H309.601C308.576 84.2276 307.565 84.1621 306.574 84.0349H286.056V60.6822V45.7496V23.5455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M699.537 38.6296L695.641 23.4238L683.84 26.4474V38.6296H699.537ZM699.537 84.0349V99.7319H715.234V84.0349H699.537ZM679.018 84.0349V68.3379H678.015L677.02 68.4656L679.018 84.0349ZM306.574 84.0349L308.572 68.4656L307.577 68.3379H306.574V84.0349ZM286.056 84.0349H270.359V99.7319H286.056V84.0349ZM309.601 -15.697C287.928 -15.697 270.359 1.87251 270.359 23.5455H301.753C301.753 19.2109 305.267 15.697 309.601 15.697V-15.697ZM521.985 -15.697H309.601V15.697H521.985V-15.697ZM521.985 15.697H675.991V-15.697H521.985V15.697ZM675.991 15.697H694.652V-15.697H675.991V15.697ZM694.652 15.697C696.819 15.697 698.576 17.4539 698.576 19.6212H729.97C729.97 0.115509 714.158 -15.697 694.652 -15.697V15.697ZM698.576 19.6212C698.576 21.4298 697.339 22.9888 695.641 23.4238L703.433 53.8353C718.681 49.9283 729.97 36.1129 729.97 19.6212H698.576ZM715.234 45.7496V38.6296H683.84V45.7496H715.234ZM715.234 60.6822V45.7496H683.84V60.6822H715.234ZM715.234 84.0349V60.6822H683.84V84.0349H715.234ZM679.018 99.7319H699.537V68.3379H679.018V99.7319ZM675.991 99.9246C677.687 99.9246 679.364 99.8162 681.016 99.6042L677.02 68.4656C676.69 68.508 676.347 68.5307 675.991 68.5307V99.9246ZM309.601 99.9246H675.991V68.5307H309.601V99.9246ZM304.576 99.6042C306.228 99.8162 307.906 99.9246 309.601 99.9246V68.5307C309.245 68.5307 308.902 68.508 308.572 68.4656L304.576 99.6042ZM286.056 99.7319H306.574V68.3379H286.056V99.7319ZM270.359 60.6822V84.0349H301.753V60.6822H270.359ZM270.359 45.7496V60.6822H301.753V45.7496H270.359ZM270.359 23.5455V45.7496H301.753V23.5455H270.359Z",
    fill: "black",
    mask: "url(#path-6-inside-1_1091_9218)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_1091_9218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4551 23.5455C31.4551 10.5417 41.9967 0 55.0005 0H296.924H486.667H510.215C518.884 0 525.912 7.02777 525.912 15.697C525.912 24.3662 518.884 31.3939 510.215 31.3939H510.213V102.03C510.213 115.034 499.671 125.576 486.667 125.576H55.0005C41.9967 125.576 31.4551 115.034 31.4551 102.03V91.8834V53.5981V23.5455Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4551 23.5455C31.4551 10.5417 41.9967 0 55.0005 0H296.924H486.667H510.215C518.884 0 525.912 7.02777 525.912 15.697C525.912 24.3662 518.884 31.3939 510.215 31.3939H510.213V102.03C510.213 115.034 499.671 125.576 486.667 125.576H55.0005C41.9967 125.576 31.4551 115.034 31.4551 102.03V91.8834V53.5981V23.5455Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M510.213 31.3939V15.697H494.516V31.3939H510.213ZM55.0005 -15.697C33.3275 -15.697 15.7581 1.87249 15.7581 23.5455H47.152C47.152 19.2109 50.6659 15.697 55.0005 15.697V-15.697ZM296.924 -15.697H55.0005V15.697H296.924V-15.697ZM296.924 15.697H486.667V-15.697H296.924V15.697ZM486.667 15.697H510.215V-15.697H486.667V15.697ZM510.215 15.697H510.215H541.609C541.609 -1.64141 527.553 -15.697 510.215 -15.697V15.697ZM510.215 15.697H510.215V47.0909C527.553 47.0909 541.609 33.0354 541.609 15.697H510.215ZM510.215 15.697H510.213V47.0909H510.215V15.697ZM525.91 102.03V31.3939H494.516V102.03H525.91ZM486.667 141.273C508.34 141.273 525.91 123.703 525.91 102.03H494.516C494.516 106.365 491.002 109.879 486.667 109.879V141.273ZM55.0005 141.273H486.667V109.879H55.0005V141.273ZM15.7581 102.03C15.7581 123.703 33.3275 141.273 55.0005 141.273V109.879C50.6659 109.879 47.152 106.365 47.152 102.03H15.7581ZM15.7581 91.8834V102.03H47.152V91.8834H15.7581ZM15.7581 53.5981V91.8834H47.152V53.5981H15.7581ZM15.7581 23.5455V53.5981H47.152V23.5455H15.7581Z",
    fill: "black",
    mask: "url(#path-8-inside-2_1091_9218)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 510.212,
    y1: 27.4693,
    x2: 698.576,
    y2: 27.4693,
    stroke: "black",
    strokeWidth: 7.84848
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_1091_9218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.665 88.6267C615.698 86.4528 612.581 86.3399 612.268 86.334H800.606C800.606 86.334 812.091 86.334 819.748 101.648C827.405 116.962 838.891 153.524 838.891 174.007C838.891 194.49 831.043 194.49 819.27 194.49C813.95 194.49 810.232 192.086 807.031 188.364H648.086C649.666 185.33 650.527 180.792 650.527 174.007C650.527 161.127 645.986 141.89 640.711 125.576H640.711C637.597 115.945 634.227 107.333 631.385 101.648C627.794 94.4657 623.36 90.6519 619.665 88.6267Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.665 88.6267C615.698 86.4528 612.581 86.3399 612.268 86.334H800.606C800.606 86.334 812.091 86.334 819.748 101.648C827.405 116.962 838.891 153.524 838.891 174.007C838.891 194.49 831.043 194.49 819.27 194.49C813.95 194.49 810.232 192.086 807.031 188.364H648.086C649.666 185.33 650.527 180.792 650.527 174.007C650.527 161.127 645.986 141.89 640.711 125.576H640.711C637.597 115.945 634.227 107.333 631.385 101.648C627.794 94.4657 623.36 90.6519 619.665 88.6267Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M619.665 88.6267L615.893 95.5095L615.893 95.5096L619.665 88.6267ZM612.268 86.334V78.4855L612.121 94.1811L612.268 86.334ZM819.748 101.648L826.768 98.1382L819.748 101.648ZM807.031 188.364L812.982 183.246L810.633 180.515H807.031V188.364ZM648.086 188.364L641.124 184.74L635.151 196.212H648.086V188.364ZM640.711 125.576V117.728H629.924L633.243 127.991L640.711 125.576ZM640.711 125.576V133.425H651.497L648.179 123.161L640.711 125.576ZM631.385 101.648L624.365 105.158L624.365 105.158L631.385 101.648ZM623.437 81.744C618.049 78.7917 613.591 78.5089 612.415 78.4869L612.121 94.1811C611.57 94.1708 613.346 94.114 615.893 95.5095L623.437 81.744ZM612.268 94.1825H800.606V78.4855H612.268V94.1825ZM800.606 86.334C800.606 94.1825 800.601 94.1825 800.596 94.1825C800.594 94.1825 800.589 94.1825 800.586 94.1824C800.579 94.1824 800.573 94.1824 800.567 94.1824C800.554 94.1823 800.543 94.1822 800.532 94.1821C800.509 94.1819 800.49 94.1815 800.472 94.1812C800.437 94.1804 800.412 94.1795 800.396 94.1788C800.364 94.1774 800.367 94.1768 800.404 94.1801C800.477 94.1868 800.678 94.2088 800.981 94.2693C801.587 94.3906 802.586 94.663 803.796 95.2681C806.105 96.423 809.659 99.0199 812.729 105.158L826.768 98.1382C822.18 88.9622 816.163 83.9021 810.816 81.2284C808.197 79.9192 805.846 79.2345 804.059 78.8772C803.166 78.6985 802.409 78.6008 801.825 78.5476C801.532 78.521 801.282 78.5055 801.078 78.4966C800.975 78.4922 800.885 78.4894 800.806 78.4877C800.767 78.4869 800.73 78.4863 800.697 78.486C800.68 78.4858 800.664 78.4857 800.649 78.4856C800.641 78.4856 800.634 78.4855 800.627 78.4855C800.623 78.4855 800.618 78.4855 800.616 78.4855C800.611 78.4855 800.606 78.4855 800.606 86.334ZM812.729 105.158C816.255 112.211 820.882 124.665 824.636 138.014C828.414 151.452 831.043 164.872 831.043 174.007H846.74C846.74 162.659 843.625 147.557 839.747 133.765C835.843 119.883 830.899 106.4 826.768 98.1382L812.729 105.158ZM831.043 174.007C831.043 183.873 829.02 185.477 828.804 185.638C828.563 185.818 827.942 186.166 826.261 186.391C824.491 186.628 822.356 186.642 819.27 186.642V202.339C822.07 202.339 825.331 202.352 828.343 201.949C831.445 201.534 834.994 200.602 838.187 198.222C844.838 193.262 846.74 184.625 846.74 174.007H831.043ZM819.27 186.642C816.889 186.642 815.177 185.799 812.982 183.246L801.081 193.482C805.287 198.373 811.011 202.339 819.27 202.339V186.642ZM807.031 180.515H648.086V196.212H807.031V180.515ZM655.047 191.988C657.497 187.283 658.375 181.234 658.375 174.007H642.678C642.678 180.35 641.834 183.376 641.124 184.74L655.047 191.988ZM658.375 174.007C658.375 159.843 653.505 139.636 648.178 123.161L633.243 127.991C638.466 144.145 642.678 162.412 642.678 174.007H658.375ZM640.711 133.425H640.711V117.728H640.711V133.425ZM648.179 123.161C645.001 113.334 641.492 104.312 638.405 98.1382L624.365 105.158C626.963 110.354 630.193 118.557 633.243 127.991L648.179 123.161ZM638.405 98.1382C634.108 89.5452 628.55 84.5463 623.436 81.7439L615.893 95.5096C618.17 96.7575 621.479 99.3862 624.365 105.158L638.405 98.1382Z",
    fill: "black",
    mask: "url(#path-11-inside-3_1091_9218)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 651.484,
    y1: 188.364,
    x2: 808.454,
    y2: 188.364,
    stroke: "black",
    strokeWidth: 15.697
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M659.333 181.788C659.333 159.09 651.291 128.97 643.249 111.576C635.207 94.1816 615.101 94.1816 615.101 94.1816H27.5245C27.5245 94.1816 7.90918 94.1816 7.90918 115.394V186.454C7.90918 186.454 7.90918 211.909 31.4475 211.909H376.481C470.34 211.909 468.182 147.53 525.557 140C582.932 132.47 607.059 165.349 615.101 178.394C623.143 191.439 627.164 204.485 639.228 204.485C651.291 204.485 659.333 204.485 659.333 181.788Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 15.697
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211.97,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6977,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.334,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 282.607,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 423.879,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 353.244,
    y: 31.394,
    width: 47.0909,
    height: 47.0909,
    rx: 11.7727,
    fill: "white",
    stroke: "black",
    strokeWidth: 7.84848
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 545.531,
    cy: 207.985,
    r: 43.1667,
    fill: "white",
    stroke: "black",
    strokeWidth: 15.697
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.878,
    cy: 207.985,
    r: 43.1667,
    fill: "white",
    stroke: "black",
    strokeWidth: 15.697
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.757,
    cy: 207.985,
    r: 43.1667,
    fill: "black",
    stroke: "white",
    strokeWidth: 15.697
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.106,
    cy: 207.985,
    r: 43.1667,
    fill: "black",
    stroke: "white",
    strokeWidth: 15.697
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharcoal);
export default __webpack_public_path__ + "static/media/charcoal.94a043974ed73eeee79402b8d717e940.svg";
export { ForwardRef as ReactComponent };